import { render, staticRenderFns } from "./ImportExportSendRestData.vue?vue&type=template&id=18e6d368"
import script from "./ImportExportSendRestData.vue?vue&type=script&lang=js"
export * from "./ImportExportSendRestData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports